module.exports = __webpack_public_path__ + "img/login_bg.f5126e1b.png";